import React from "react";
import earth from "../asset/earth_PNG8.png"



const AnimatedText = () => {


  return (
    <section className="container">
<div className="scene">
    <div className="banner">
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
      <div className="panel"></div>
    </div>
    <img src={earth} alt="earthImage" className="screen"/>
   </div>
    </section>
  )
}

export default AnimatedText